module.exports = __webpack_public_path__ + "static/loading-134d965b4092f4f4ed64b97fc0f9fe01.png";